import React, { useEffect, useState } from "react";
import {
  getAllWarehouseInventoryDispatch,
  getAllStoresByCountryCode,
} from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import { Grid } from "react-bootstrap";
import Card from "components/Card/Card";
import WarehouseInventoryTable from "./warehouseInventoryTable";
import WarehouseInventoryFilter from "./warehouseInventoryDispatchFilter";
import ScreenLoader from "views/Components/screenLoader";
import { deleteWarehouseInventoryDispatchById } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import NotificationSystem from "react-notification-system";
import Swal from "sweetalert2";
import LoadingSpinner from "views/Components/loadingSpinner";
import moment from "moment";
import { Button } from "react-bootstrap";
import { UpdateWarehouseInventoryDispatchStatus } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";

const WarehouseInventoryDispatchView = (props) => {
  const _notificationSystem = React.createRef();
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [loading, setLoading] = useState(true);
  const [warehouseInventoryDispatchData, setWarehouseInventoryDispatchData] =
    useState([]);
  const [filterByStatus, setFilterByStatus] = useState("");
  const [filterByUser, setFilterByUser] = useState("");
  const [filterByStore, setFilterByStore] = useState("");
  const [getAllStores, setGetAllStores] = useState([]);
  const [isDateRangePickerOpen, setIsDateRangePickerOpen] = useState(false);
  const [selecttedRange, setSelecttedRange] = useState("");
  const [selecttedStatus, setSelecttedStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [filterByWarehouseDispatchId, setFilterByWarehouseDispatchId] =
    useState("");

  useEffect(() => {
    fetchWarehouseInventoryData();
    fetchAllStores();
    const intervalId = setInterval(() => {
      fetchWarehouseInventoryData();
    }, 18000);
    return () => clearInterval(intervalId);
  }, [
    filterByWarehouseDispatchId,
    filterByStatus,
    filterByStore,
    selecttedRange,
    currentPage,
  ]);

  const fetchWarehouseInventoryData = async () => {
    let page = currentPage;
    setLoading(true);
    try {
      let startDate = "";
      let endDate = "";
      if (selecttedRange) {
        startDate = selecttedRange.start
          ? moment(selecttedRange.start).format("YYYY-MM-DD")
          : "";
        endDate = selecttedRange.end
          ? moment(selecttedRange.end).format("YYYY-MM-DD")
          : "";
      }
      const response = await getAllWarehouseInventoryDispatch(
        page,
        filterByWarehouseDispatchId,
        filterByStore ? filterByStore.value : "",
        filterByStatus ? filterByStatus.value : "",
        startDate,
        endDate,
        obj
      );
      setWarehouseInventoryDispatchData(response.data);
      setTotalPage(response.meta.last_page);
      setCurrentPage(response.meta.current_page);
      console.log("Warehouse Inventory Data:", response.data);
    } catch (error) {
      console.error("Error fetching warehouse inventory data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllStores = async () => {
    const countryCode = "LK";
    try {
      const response = await getAllStoresByCountryCode(countryCode, obj);
      const stores = response.data.map((store) => {
        return {
          value: store.id,
          label: store.name,
        };
      });
      setGetAllStores(stores);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };

  const handleNavigateToAddWarehouseInventoryDispatch = () => {
    props.history.push("/admin/add-warehouse-inventory-dispatch");
  };

  const handleNavigateToEditWarehouseInventoryDispatch = (id) => {
    props.history.push(`/admin/edit-warehouse-inventory-dispatch/${id}`);
  };
  const onToggle = () => {
    setIsDateRangePickerOpen(!isDateRangePickerOpen);
  };

  const handleStatusUpdate = (id) => {
    Swal.fire({
      width: "478px",
      title:
        "<div style='font-size:26px;font-weight: 100;'>Do you want to update the status to 'Completed'? </div>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "<font size='3px'>Yes, update it!</font>",
      cancelButtonText: "<font size='3px'>Cancel</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        updateStatus(id);
      }
    });
  };

  const updateStatus = async (id) => {
    try {
      const body = { id: Number(id), status: 4 };
      const response = await UpdateWarehouseInventoryDispatchStatus(body, obj);

      if (response.data.success) {
        _notificationSystem.current.addNotification({
          message: "Warehouse Inventory Dispatch status updated successfully!",
          level: "success",
        });
        fetchWarehouseInventoryData();
      } else {
        _notificationSystem.current.addNotification({
          message: response.data.message || "Failed to update status.",
          level: "error",
        });
      }
    } catch (error) {
      console.error(
        "Error updating warehouse inventory dispatch status:",
        error
      );
      _notificationSystem.current.addNotification({
        message: "Error updating Warehouse Inventory Dispatch status.",
        level: "error",
      });
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      width: "500px",
      title: "<font size='6px'>Are you sure?</font>",
      text: "You won't be able to revert this! ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "<font size='3px'>Yes, Delete it!</font>",
      cancelButtonText: "<font size='3px'>Cancel</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteWarehouseInventoryDispatch(id);
      }
    });
  };

  const deleteWarehouseInventoryDispatch = async (id) => {
    try {
      console.log("Deleting warehouse inventory dispatch with ID:", id);
      const res = await deleteWarehouseInventoryDispatchById(id, obj);
      console.log("Delete response:", res);
      if (res.success) {
        _notificationSystem.current.addNotification({
          message: "Warehouse Inventory Dispatch deleted successfully!",
          level: "success",
        });
        const intervalId = setInterval(() => {
          fetchWarehouseInventoryData();
        }, 1000);
        setTimeout(() => {
          clearInterval(intervalId);
        }, 1000);
      } else {
        _notificationSystem.current.addNotification({
          message: "Failed to delete Warehouse Inventory Dispatch.",
          level: "error",
        });
      }
    } catch (error) {
      console.error("Error deleting warehouse inventory dispatch:", error);
      _notificationSystem.current.addNotification({
        message: "Error deleting Warehouse Inventory Dispatch.",
        level: "error",
      });
    }
  };

  const handleStatusStyle = (status) => {
    switch (status) {
      case "Completed":
        return (
          <Button
            className=" badge-fill fl_text_green"
            style={{
              padding: "auto",
              width: "auto",
              textTransform: "capitalize",
              cursor: "default",
              pointerEvents: "none",
              opacity: 1,
              border: "none",
            }}
          >
            Completed
          </Button>
        );
      case "Dispatched":
        return (
          <Button
            className="badge-fill fl_text_navyBlue"
            style={{
              padding: "auto",
              width: "auto",
              textTransform: "capitalize",
              cursor: "default",
              pointerEvents: "none",
              opacity: 1,
              border: "none",
            }}
          >
            Dispatched
          </Button>
        );
      default:
        return (
          <Button
            className=" badge-fill fl_text_orange"
            style={{
              padding: "auto",
              width: "auto",
              textTransform: "capitalize",
              cursor: "default",
              pointerEvents: "none",
              opacity: 1,
              border: "none",
            }}
          >
            -
          </Button>
        );
    }
  };

  return (
    <div className="main-content">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <Card
          tableFullWidth
          content={
            <>
              <WarehouseInventoryFilter
                filterByStatus={filterByStatus}
                setFilterByStatus={setFilterByStatus}
                filterByUser={filterByUser}
                setFilterByUser={setFilterByUser}
                filterByStore={filterByStore}
                setFilterByStore={setFilterByStore}
                getAllStores={getAllStores}
                setfilterByWarehouseDispatchId={setFilterByWarehouseDispatchId}
                filterBywarehouseDispatchId={filterByWarehouseDispatchId}
                handleNavigateToAddWarehouseInventoryDispatch={
                  handleNavigateToAddWarehouseInventoryDispatch
                }
                isDateRangePickerOpen={isDateRangePickerOpen}
                setIsDateRangePickerOpen={setIsDateRangePickerOpen}
                onToggle={onToggle}
                selecttedRange={selecttedRange}
                setSelecttedRange={setSelecttedRange}
                selectedStatus={selecttedStatus}
                setSelectedStatus={setSelecttedStatus}
                // handleUpdateStatus={handleUpdateStatus}
              />
              <WarehouseInventoryTable
                inventoryData={warehouseInventoryDispatchData}
                setInventoryData={setWarehouseInventoryDispatchData}
                handleNavigateToEditWarehouseInventoryDispatch={
                  handleNavigateToEditWarehouseInventoryDispatch
                }
                handleDelete={handleDelete}
                handleStatusUpdate={handleStatusUpdate}
                handleStatusStyle={handleStatusStyle}
                currentPage={currentPage}
                totalPage={totalPage}
                setCurrentPage={setCurrentPage}
                loading={loading}
                LoadingSpinner={LoadingSpinner}
              />
            </>
          }
        />
      </Grid>
    </div>
  );
};
export default WarehouseInventoryDispatchView;
